import { render, staticRenderFns } from "./basicpreparations.vue?vue&type=template&id=54f3413e"
import script from "./basicpreparations.vue?vue&type=script&lang=js"
export * from "./basicpreparations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54f3413e')) {
      api.createRecord('54f3413e', component.options)
    } else {
      api.reload('54f3413e', component.options)
    }
    module.hot.accept("./basicpreparations.vue?vue&type=template&id=54f3413e", function () {
      api.rerender('54f3413e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basicconfig/basicpreparations.vue"
export default component.exports